import React from "react";

import "./Textarea.css";

type InputFieldProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  required?: boolean;
  error?: string;
  placeholder?: string;
};

const Textarea: React.FC<InputFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  error,
  placeholder,
}) => {
  return (
    <div className="input-area">
      <label>
        {label} {required && <span className="text-red">*</span>}
      </label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        className={`${error ? "border-red" : ""}`}
        rows={6}
        placeholder={placeholder}
      />
    </div>
  );
};

export default Textarea;
